<div fxLayout="row" class="entity-path" *appVar="selectedEntity|async as selection">
    <span *ngFor="let p of mkPathComponents(path); let last=last">
        <ng-container *appVar="isDisabled(p.path, selection) as disabled">
            <span [ngClass]="{'path-link': !disabled}"
                  [title]="disabled ? '' : ('View {0}'|i18n:(p.path|nicePath:false))"
                  (click)="onSelectEntity(p.path)">{{p.segment}}</span>
            <ng-container *ngIf="!last && putSpace">&nbsp;&gt;&nbsp;</ng-container>
            <ng-container *ngIf="!last && !putSpace">&gt;</ng-container>
        </ng-container>
    </span>
</div>
